
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { supabase } from "@/integrations/supabase/client";

export const requiredColumns = ["email", "mobile_number", "school_id"];

export const validateFileData = (data: any[]) => {
  if (data.length === 0) {
    return { isValid: false, error: "The file contains no data." };
  }

  const columns = Object.keys(data[0]);
  const missingColumns = requiredColumns.filter(col => !columns.includes(col));

  if (missingColumns.length > 0) {
    return {
      isValid: false,
      error: `Missing required columns: ${missingColumns.join(", ")}`
    };
  }

  return { isValid: true, error: null };
};

export const processExcelFile = async (file: File): Promise<any[]> => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer);
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  return XLSX.utils.sheet_to_json(worksheet);
};

export const processCsvFile = (file: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => resolve(results.data),
      error: (error) => reject(error)
    });
  });
};

export const importStaffToSupabase = async (data: any[]): Promise<{ success: boolean; error?: string }> => {
  try {
    // Prepare staff entries for insertion
    const staffEntries = data.map(row => ({
      email: String(row.email).toLowerCase().trim(),
      mobile_number: String(row.mobile_number || ''),
      school_id: String(row.school_id)
    }));

    const batchSize = 100;
    let hasErrors = false;
    let errorDetails = "";

    for (let i = 0; i < staffEntries.length; i += batchSize) {
      const batch = staffEntries.slice(i, i + batchSize);
      const { error } = await supabase.from('staff').insert(batch);
      
      if (error) {
        console.error('Error inserting staff batch:', error);
        hasErrors = true;
        errorDetails = error.message;
        break;
      }
    }

    if (hasErrors) {
      return { success: false, error: errorDetails };
    }

    return { success: true };
  } catch (error: any) {
    console.error('Error in importStaffToSupabase:', error);
    return { success: false, error: error.message };
  }
};
